<script>
    import { BCollapse } from 'bootstrap-vue';
    import MediaPackageContent from './MediaPackageContent.vue';
    import MediaPackageDelete from './MediaPackageDelete';
    import ImagePreview from './ImagePreview.vue';
    import ShareStatus from './ShareStatus.vue';
    import ShareUsers from './ShareUsers.vue';
    import ShareUsersCreate from './ShareUsersCreate.vue';
    import DownloadButton from './DownloadButton.vue';
    import SendMail from './SendMail';
    import {handleScoopAjaxError} from '../../../../resources/js/mixins/axios-response-errors'

    export default {
        components: {
            'media-package-content': MediaPackageContent,
            'media-package-delete': MediaPackageDelete,
            'image-preview': ImagePreview,
            'share-status': ShareStatus,
            'share-users': ShareUsers,
            'share-users-create': ShareUsersCreate,
            'download-button': DownloadButton,
            'send-mail': SendMail,
            BCollapse,
        },
        model: {
            prop: 'package',
            event: 'set-package'
        },
        props: {
            package: {
                type: Object,
                default: null
            },
            openedWithinModal: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                baseUrl: Scoop.baseUrl,
                openShareUserPanel: false,
                showSendMail: false,
            }
        },
        mounted() {
            new ClipboardJS('.btn-clipboard');
            this.listenForEvents();
        },
        watch: {
            package() {
                this.listenForEvents();
            }
        },
        methods: {
            updateShare(dataToUpdate) {
                this.validShare = _.merge(this.validShare, dataToUpdate); // See computed properties setter
            },
            listenForEvents() {
                if (!this.validShare ||
                    this.validShare.download_generated_at ||
                    this.validShare.download_failed_at
                ) {
                    // Dont listen for events if there cannot be any progress anymore (downloads completed)
                    return;
                }

                if (!window.Echo) {
                    console.log('Push deactivated')
                    return null;
                }

                console.log('tracking progress', this.validShare.package_id);

                window.Echo.private(`downloadpackage.${this.validShare.id}`)
                    .listen('\\Scoop\\Packages\\Events\\PackageDownloadScheduled', (data) => {
                        console.log('PackageDownloadScheduled', data);
                        this.updateShare(data.share);
                    })
                    .listen('\\Scoop\\Packages\\Events\\PackageDownloadStarted', (data) => {
                        console.log('PackageDownloadStarted', data);
                        this.updateShare(data.share);
                    })
                    .listen('\\Scoop\\Packages\\Events\\PackageDownloadGenerated', (data) => {
                        console.log('PackageDownloadGenerated', data);
                        this.updateShare(data.share);
                    })
                    .listen('\\Scoop\\Packages\\Events\\PackageDownloadFailed', (data) => {
                        console.log('PackageDownloadFailed', data);
                        this.updateShare(data.share);
                    });
            },
            setPublic(isPublic) {
                axios.patch(Scoop.baseUrl + `/mediaserver/packages/${this.package.id}/share/${this.validShare.id}`,
                    { is_public : isPublic }
                )
                    .then(response => {
                        this.validShare.is_public = isPublic;
                        toastr.info('Public access has been changed');
                    })
                    .catch(error => handleScoopAjaxError(error, 'Public access could not be changed'));
            },
            toggleSendMail() {
                this.showSendMail = !this.showSendMail;
            },
        },
        computed: {
            packageMutable: {
                get() {
                    return this.package;
                },
                set(newValue) {
                    this.$emit('set-package', newValue);
                }
            },
            validShares() {
                if (!this.package.valid_shares) {
                    return [];
                }

                return this.package.valid_shares;
            },
            validShare: {
                get() {
                    if (!this.package.valid_shares || !this.package.valid_shares.length) {
                        return null;
                    }

                    return this.package.valid_shares[0];
                },
                set(newValue) {
                    if (!this.package.valid_shares || !this.package.valid_shares.length) {
                        return;
                    }

                    let updatePackage = this.package;

                    updatePackage.valid_shares[0] = newValue;

                    this.$emit('set-package', updatePackage);
                }
            },
            sharedWithUsers() {
                if (!this.validShare || !this.validShare.users) {
                    return [];
                }

                return this.validShare.users;
            },
            packageName() {
                if (this.package.package_name_short) {
                    return this.package.package_name_short;
                }

                return __('scoop-os.packages.default_package_name', {'id': this.package.id})
            }
        }
    }
</script>
<template>
    <div :id="'package'+package.id" class="panel panel-default">

        <div class="panel-heading">
            <media-package-content
                    v-model="packageMutable"
                    class="inline">
                <a slot="opener">
                    <strong v-text="__('scoop-os.packages.link.x_mediafiles', {
                        name: packageName,
                        count: package.contents.length
                    })">
                    </strong>
                </a>
            </media-package-content>

            <media-package-delete
                    :package-id="package.id"
                    :package-name="packageName"
                    v-if="!openedWithinModal && validShare && validShare.download_generated_at && package.current_user_is_admin"
            ></media-package-delete>

            <share-status v-model="package" class="pull-right"></share-status>
        </div>
        <div class="panel-body">

            <div class="row">

                <div class="col-md-9">
                    <image-preview
                            v-if="!openedWithinModal"
                            v-model="package"
                            class="pull-right"
                            countVisible="3"
                    ></image-preview>

                    <div class="media-body">
                        <strong v-text="package.creator.fullName"></strong>

                        created this package
                        <span v-text="package.created_since" :title="package.created_at"></span>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="pull-right">
                        <download-button v-if="validShare" :share="validShare"></download-button>
                    </div>
                </div>
            </div>

        </div>
        <div class="panel-footer" style="background-color: #FFF" v-if="validShare && validShare.download_generated_at">
            <div class="row">
                <div class="col-lg-12">
                    <a @click.prevent="openShareUserPanel = !openShareUserPanel">
                        <i class="fa fa-fw"
                           :class="openShareUserPanel ? 'fa-angle-down' : 'fa-angle-right'"
                           aria-hidden="true"
                        ></i>
                        <template v-if="validShare.is_public && sharedWithUsers.length">
                            <i class="fa fa-users" aria-hidden="true"></i>
                            Shared with <strong>public</strong> and <a href="#">{{ sharedWithUsers.length }}&nbsp;users</a>
                        </template>
                        <template v-if="validShare.is_public && !sharedWithUsers.length">
                            <i class="fa fa-users" aria-hidden="true"></i>
                            Shared with <strong>public</strong>
                        </template>
                        <template v-if="!validShare.is_public && !sharedWithUsers.length">
                            <i class="fa fa-lock" aria-hidden="true"></i>
                            Not shared with any user yet
                        </template>
                        <template v-if="!validShare.is_public && sharedWithUsers.length">
                            <i class="fa fa-unlock-alt" aria-hidden="true"></i>
                            Shared with <a href="#">{{ sharedWithUsers.length }}&nbsp;users</a>
                        </template>
                    </a>
                </div>
            </div>

            <div class="row" :class="{ 'm-t-sm' : openShareUserPanel }">
                <div class="col-lg-12">
                    <b-collapse id="shareUserPanel" v-model="openShareUserPanel">
                        <div v-if="!validShare.is_public" class="alert alert-info">
                            Public download is not permitted
                            <a v-if="package.current_user_is_admin" @click="setPublic(1)" class="btn btn-xs btn-danger pull-right">
                                Activate public access
                            </a>
                        </div>
                        <div v-if="validShare.is_public" class="alert alert-info">
                            <div :class="[ package.current_user_is_admin ? 'm-b-md' : 'm-b-xs' ]">
                                Public download URL
                                <a v-if="package.current_user_is_admin" @click="setPublic(0)" class="btn btn-xs btn-danger pull-right">
                                    Deactivate public access
                                </a>
                            </div>
                            <div class="input-group">
                                <input :id="'downloadUrl'+validShare.id"
                                       type="text"
                                       class="form-control input-sm full-width"
                                       :value="validShare.url"
                                       @blur="$event.target.select()"
                                       @click="$event.target.select()"
                                >

                                <div class="input-group-btn">
                                    <button :data-clipboard-target="'#downloadUrl'+validShare.id"
                                            class="btn btn-sm btn-default btn-clipboard">
                                        <i class="fa fa-clipboard" aria-hidden="true"></i>
                                    </button>
                                    <button v-if="package.current_user_is_admin" class="btn btn-sm btn-default"
                                            @click="toggleSendMail()"
                                    >
                                        <i class="fa fa-envelope-o" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </div>
                            <send-mail :id="'share-link-'+validShare.id" :package="package" v-show="showSendMail"></send-mail>
                        </div>
                        <div class="chat-activity-list">
                            <share-users
                                    v-for="(sharedWithUser, idx) in sharedWithUsers"
                                    :key="sharedWithUser.id"
                                    :package="packageMutable"
                                    @packageChanged="$emit('set-package', $event)"
                                    :shared-user="sharedWithUsers[idx]"
                                    class="chat-element"
                            >
                            </share-users>
                        </div>
                        <div v-if="package.current_user_is_admin" class="row">
                            <div class="col-lg-12">
                                <share-users-create
                                        :package="packageMutable"
                                        @packageChanged="$emit('set-package', $event)"
                                ></share-users-create>
                            </div>
                        </div>
                    </b-collapse>
                </div>
            </div>
        </div>
    </div>
</template>
